// extracted by mini-css-extract-plugin
export default {"invoiceLineRow":"project-cancellation-invoice_invoiceLineRow__9fM4S"};